// extracted by mini-css-extract-plugin
export default {"main":"fc821b054b a48c56335f _86c81cc6dc _544bd324aa","title":"_31d9e2f9f4"};